import { invoke, actions } from '@shared/easyfy.decorators';
import PageSubCategoryExpander from '@webModules/pageSubCategoriesExpander';

namespace Easyfy.Web.Pages {
  @invoke
  class ArticleList {
    static Instance: ArticleList;

    private subCatExpander: PageSubCategoryExpander;

    constructor() {
      ArticleList.Instance = this;
      this.subCatExpander = new PageSubCategoryExpander();
    }

    onInit() {
      ArticleList.Instance.subCatExpander.InitElements();
    }
  }
}

export default Easyfy.Web.Pages;
